import React from "react";
import { Section } from "@/components/Section";

export function Privacy() {
  return (
    <div data-testid="privacy-page">
      <div className="border-b border-[#151515] pt-24 pb-12 bg-black">
        <div className="max-w-[900px] mx-auto px-5"><h1 className="type-h2">Privacy Policy</h1></div>
      </div>
      <Section>
        <div className="max-w-3xl text-[#c9c9c9] space-y-4 text-sm leading-relaxed">
          <p>Ironveil Era Sports Private Limited (&ldquo;Ironveil Era&rdquo;, &ldquo;we&rdquo;) processes personal information submitted through athlete registration and partnership enquiry forms for the sole purpose of evaluating and administering combat-sports events, athlete records and partnership relationships.</p>
          <p>We do not sell your personal information. Uploaded athlete photos and supporting documents are stored securely and are only used internally for eligibility, event administration and athlete profiling.</p>
          <p>You may contact <a href="mailto:hello@ironveilera.com" className="text-[#C8102E]">hello@ironveilera.com</a> at any time to request access, correction or deletion of your data.</p>
          <p>By submitting a form on this website, you consent to the processing described in this policy.</p>
        </div>
      </Section>
    </div>
  );
}

export function Terms() {
  return (
    <div data-testid="terms-page">
      <div className="border-b border-[#151515] pt-24 pb-12 bg-black">
        <div className="max-w-[900px] mx-auto px-5"><h1 className="type-h2">Terms &amp; Conditions</h1></div>
      </div>
      <Section>
        <div className="max-w-3xl text-[#c9c9c9] space-y-4 text-sm leading-relaxed">
          <p>Use of this website is subject to these terms. Content on this website is the property of Ironveil Era Sports Private Limited unless otherwise credited.</p>
          <p>Athlete registrations, partnership enquiries and event information published on this website are subject to review and confirmation by the Ironveil Era team. Submitting a form does not create any binding participation, contractual, or partnership obligation.</p>
          <p>Ironveil Era reserves the right to update event details, rules, eligibility criteria and rankings at any time.</p>
        </div>
      </Section>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5" data-testid="notfound-page">
      <div className="text-center">
        <div className="font-display text-[#C8102E] text-xs">Error 404</div>
        <h1 className="type-h1 mt-3">Off the Card</h1>
        <p className="mt-4 text-[#a0a0a0]">This page isn&apos;t part of the Ironveil Era.</p>
        <a href="/" className="btn-primary mt-8 inline-flex">Back to Home</a>
      </div>
    </div>
  );
}
